import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import createOidcMiddleware from 'redux-oidc';
import RootReducers from 'redux/rootReducer';
import userManager from 'Shared/Auth/UserManager/userManager';
import history from 'redux/history';

const oidcMiddleware = createOidcMiddleware(userManager);

const Store = createStore(
  RootReducers,
  (process.env.NODE_ENV !== 'production') ? composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk, oidcMiddleware))
    : applyMiddleware(routerMiddleware(history), thunk, oidcMiddleware),
);
export default Store;
